import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestForwardCookieGet = {
    path: "/forward/cookie/:slug",
    method: RouteHttpVerb.GET
};
